import axios from 'axios'
import { apiEndpoints, SERVER_PATH } from '../endpoints'

export default async () => {
  const URL = SERVER_PATH + apiEndpoints.me
  return axios.get(URL, { withCredentials: true })
}
